module.exports = __webpack_public_path__ + "static/media/portada.3e6630cd.jpg";